import { BACKEND_API_URL } from "../config";
import getPrepareedRTKAuthHeaders from "../utils/getPrepareedRTKAuthHeaders";

const RTKBaseQuery = {
  baseUrl: BACKEND_API_URL,
  prepareHeaders: getPrepareedRTKAuthHeaders,
};

export default RTKBaseQuery;
